import { BusinessApi } from 'shared/api';
import { IUpdateOwnerInfoDto } from 'shared/api/business/interfaces/update-owner-info-dto.interface';

export const updateOwnerInfo = async (
  email: string,
  fio: string,
  phone: string
) => {
  const { id: ownerId } = await BusinessApi.getAccountInfo();
  const dto: IUpdateOwnerInfoDto = {
    ownerId,
    email,
    fio,
    phone,
  };

  return BusinessApi.updateOwnerInfo(dto);
};
